import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16H18C18.2652 16 18.5196 15.8946 18.7071 15.7071C18.8946 15.5196 19 15.2652 19 15V8.41421L14.5859 4.00011L10 4ZM7.87868 2.87868C8.44129 2.31607 9.20435 2 10 2H14.586C15.1163 2.00011 15.6251 2.21086 16.0001 2.58589M16.0001 2.58589L20.414 6.99979C20.414 6.99975 20.414 6.99982 20.414 6.99979C20.789 7.37476 20.9999 7.88345 21 8.41379V15C21 15.7957 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7957 18 18 18H17V19C17 19.7957 16.6839 20.5587 16.1213 21.1213C15.5587 21.6839 14.7957 22 14 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7957 3 19V9C3 8.20435 3.31607 7.44129 3.87868 6.87868C4.44129 6.31607 5.20435 6 6 6H7V5C7 4.20435 7.31607 3.44129 7.87868 2.87868M7 8H6C5.73478 8 5.48043 8.10536 5.29289 8.29289C5.10536 8.48043 5 8.73478 5 9V19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20H14C14.2652 20 14.5196 19.8946 14.7071 19.7071C14.8946 19.5196 15 19.2652 15 19V18H10C9.20435 18 8.44129 17.6839 7.87868 17.1213C7.31607 16.5587 7 15.7957 7 15V8Z"
    />
  </svg>
);

const DocumentDuplicateIcon = (props) => <Icon component={SVG} {...props} />;

export default DocumentDuplicateIcon;
